import { IApplicationState } from '../../types/redux';

export function getTotalCount(state: IApplicationState) {
  const { tab } = state;

  return state[tab].listing.total;
}
